/* global window */

import get from 'lodash/get';

const isOrigin = document.location.href.includes('htvapps');

const settings = {
  playerClass: 'hearstLumierePlayer',
  loadingClass: 'playerLoading',
  loadedClass: 'playerLoaded',
  dataAttributePrefix: 'data-player',
  loggingLevel: 'all',
  timeout: 5000,

  nitehawkBaseUrl: get(window, 'LUMIERE_NITEHAWK_URL', 'https://nitehawk.hearst.io'),
  animeBaseUrl: 'https://anime.htvtools.us/v1/prod/animated-gifs',
  imaSdkUrl: 'https://imasdk.googleapis.com/js/sdkloader/ima3.js',
  daiSdkUrl: 'https://imasdk.googleapis.com/js/sdkloader/ima3_dai.js',

  adsManagerLoaded: false,
  adSettings: {
    adsRenderingSettings: {
      bitrate: -1,
      // Timeout (in milliseconds) when loading a video ad media file.
      // If loading takes longer than this timeout, the ad playback is canceled
      // and the next ad in the pod plays, if available.
      // Use -1 for the default of 8 seconds.
      loadVideoTimeout: 10000,
    },
    contribAdsSettings: {
      // The maximum amount of time to wait for an ad implementation
      // to initialize before playback, in milliseconds.
      // If the viewer has requested playback and the ad implementation
      // does not fire adsready before this timeout expires,
      // the content video will begin playback.
      timeout: 13000,
      // The maximum amount of time to wait for an ad implementation
      // to initiate a preroll, in milliseconds. If readyforpreroll has been fired
      // and the ad implementation does not call startLinearAdMode() before
      // prerollTimeout expires, the content video will begin playback.
      prerollTimeout: 1000,
    },
    // Override for default VAST load timeout in milliseconds for a single wrapper.
    // The default timeout is 5000ms.
    vastLoadTimeout: 6000,

    // google.ima.ImaSdkSettings.VpaidMode.DISABLED = 0
    // google.ima.ImaSdkSettings.VpaidMode.ENABLED = 1
    // google.ima.ImaSdkSettings.VpaidMode.INSECURE = 2
    vpaidMode: get(window, 'LUMIERE_VPAID_INSECURE', false) ? 2 : 1,
  },

  canAutoplay: true,
  imaSdkAvailable: false,
  adBlockDetected: false,
  canUseWebP: false,
  doNotSellStatus: false,
  enableAmazonBids: get(window, 'LUMIERE_AMAZON_BIDS', true),

  enableAutoAdvance: false,
  autoAdvanceDelayInSeconds: 0,

  sentrySettings: {
    dsn: null,
    release: null,
    attachStacktrace: true,
    debug: isOrigin,
    // https://docs.sentry.io/platforms/javascript/configuration/filtering/#decluttering-sentry
    ignoreErrors: [
      'top.GLOBALS',
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'http://tt.epicplay.com',
      'Can\'t find variable: ZiteReader',
      'jigsaw is not defined',
      'ComboSearch is not defined',
      'http://loading.retry.widdit.com/',
      'atomicFindClose',
      'fb_xd_fragment',
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      'conduitPage',
    ],
    allowUrls: [/https?:\/\/assets\.htvapps\.com\/encore/i],
  },
};

export default settings;
